import React from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { ArrowRight, CheckCircle, Calculator } from "lucide-react";
import { mockData } from "../mock";

const PricingSection = () => {
  const { pricing } = mockData;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          {/* Clean Header - Welcome.com Style */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Simple, 
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600"> 
              {" "}Transparent
            </span>
            {" "}Pricing
          </h2>
          
          {/* Professional Subtitle */}
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-8 leading-relaxed font-medium">
            Straightforward pricing with no hidden fees. Choose the plan that fits your organization's needs.
          </p>
          
          <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-emerald-500 mx-auto rounded-full mb-12"></div>
          
          {/* Clean Stats */}
          <div className="flex flex-wrap justify-center gap-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600 mb-2">$0</div>
              <div className="text-gray-600 font-medium">Setup Fee</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-emerald-600 mb-2">100%</div>
              <div className="text-gray-600 font-medium">Transparent</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">24hrs</div>
              <div className="text-gray-600 font-medium">Response Time</div>
            </div>
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          <Card className="border-0 bg-white shadow-sm p-8">
            <CardContent className="p-0 text-center">
              <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center">
                <Calculator className="h-8 w-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Size & Sector Calibrated Pricing
              </h3>
              
              <p className="text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
                Our transparent pricing model considers your organization's size and industry sector, 
                ensuring fair and accessible certification for all conscious businesses.
              </p>

              {/* Pricing tiers preview */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                <div className="p-6 bg-gray-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                  <h4 className="font-bold text-gray-900 mb-2">Micro & Small</h4>
                  <p className="text-gray-600 mb-2">1-50 employees</p>
                  <p className="text-gray-500 text-sm">Startup-friendly pricing</p>
                </div>
                <div className="p-6 bg-green-50 rounded-xl border-2 border-green-200 hover:shadow-md transition-shadow duration-300">
                  <h4 className="font-bold text-gray-900 mb-2">Medium</h4>
                  <p className="text-gray-600 mb-2">51-500 employees</p>
                  <p className="text-green-600 text-sm font-medium">Most popular</p>
                </div>
                <div className="p-6 bg-gray-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                  <h4 className="font-bold text-gray-900 mb-2">Large & Enterprise</h4>
                  <p className="text-gray-600 mb-2">500+ employees</p>
                  <p className="text-gray-500 text-sm">Volume discounts available</p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
                <a href="/pricing">
                  <Button
                    size="lg"
                    className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    See Pricing Details
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </a>
                <a href="/signup">
                  <Button
                    size="lg"
                    variant="outline"
                    className="border-green-300 text-green-600 hover:bg-green-50 px-8 py-4 text-lg font-semibold transition-all duration-300"
                  >
                    Get Started
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </a>
              </div>
              
              <p className="text-sm text-gray-500">
                Free consultation • No commitment required • Response within 24 hours
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;